import { ModalController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { Component, Input, OnInit } from "@angular/core";
import { ModalSelectDropdownSettings } from "./modal-select-dropdown.model";

@Component({
  selector: "app-modal-sort",
  templateUrl: "./modal-select-dropdown.component.html",
  styleUrls: ["./modal-select-dropdown.component.scss"],
})
export class ModalSelectDropdownComponent {
  @Input()
  modalSettings: ModalSelectDropdownSettings;

  @Input()
  clearButton: boolean = false;

  outputData;

  constructor(
    public translate: TranslateService,
    private modalCtrl: ModalController
  ) {}

  back() {
    this.modalCtrl.dismiss();
  }

  sortChange(event) {
    this.outputData = event;
  }

  save() {
    if(((this.modalSettings.currentValue != null) || (this.modalSettings.currentValue != undefined)) && this.outputData == undefined){
      this.outputData = this.modalSettings.currentValue
    }

    this.modalCtrl.dismiss(this.outputData);
    this.back();
  }

  clear() {
    this.modalCtrl.dismiss('clearEvent');
  }
}
